import { useMemo } from 'react';
import { toBookDetailPublics } from 'src/mapper/Public.mapper';
import { IResponse } from 'src/types/DTO/IResponse';
import { IBookDetailPublic } from 'src/types/DTO/public/IBookDetailPublic';
import { IParamBasic } from 'src/types/ParamBasic';
import { endpoints } from 'src/utils/axios';
import useSWR from 'swr';
import axiosPublic, { fetcherPublic } from './base';

// ----------------------------------------------------------------------
export function useFindDetailBookByIds(
  params?: IParamBasic & {
    ids?: number[] | string[];
  }
) {
  const URL = params?.ids
    ? [
        endpoints.public.find_book_detail_by_ids,
        {
          params: {
            ...params,
          },
        },
      ]
    : null;

  const { data, isLoading, error, isValidating, mutate } = useSWR<IResponse<IBookDetailPublic[]>>(
    URL,
    fetcherPublic
  );

  const bookDetail = toBookDetailPublics(data?.data.list);
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          list: bookDetail || [],
          pagination: data?.data.pagination,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function findDetailBookByIds(
  params?: IParamBasic & {
    ids?: number[] | string[];
  }
) {
  const URL = endpoints.public.find_book_detail_by_ids;

  const { data } = await axiosPublic.get(URL, {
    params,
  });
  const book = toBookDetailPublics(data?.data.list);
  return { ...data, data: { ...data.data, list: book } };
}

// ----------------------------------------------------------------------
